import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./Config/authConfig";
import { Provider } from "react-redux";
import { store, persistor } from "./Redux/store";
import { PersistGate } from "redux-persist/integration/react";
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import App from './App';

const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(document.getElementById('root'));
// Ensure MSAL is initialized before rendering the app
msalInstance.initialize().then(() => {
  root.render(
      <MsalProvider instance={msalInstance}>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
          <I18nextProvider i18n={i18n}>
            <App />
            </I18nextProvider>
          </PersistGate>
        </Provider>
      </MsalProvider>
  );
});


